import { ToggleButton } from '@mui/material';
import { useSummaryType } from '../contexts/SummaryTypeContext';

export default function SummaryTypeToggle() {
    const { summaryType, setSummaryType } = useSummaryType();

    return (
        <ToggleButton
            color="primary"
            value="simple"
            size="small"
            selected={summaryType === 'simple'}
            onChange={() => {
                setSummaryType(summaryType === 'simple' ? 'detailed' : 'simple');
            }}
            sx={{ lineHeight: '1', textTransform: 'none' }}>
            Eenvoudig
        </ToggleButton>
    );
}
